export const storeAuthToken = (token) => {
  window.localStorage.setItem("auth_token", token);
  //log token
    console.log(token);
};

export const getAuthToken = () => {
  console.log("AUTH TOKEN", window.localStorage.getItem("auth_token"))
  return window.localStorage.getItem("auth_token");
};

export const storeResetToken = (token) => {
  window.localStorage.setItem("reset_token", token);
  //log token
  console.log(token);
};

export const getResetToken = () => {
  return window.localStorage.getItem("reset_token");
};